export default __webpack_public_path__ + "static/media/spec-typography.e89cede0.png";